export const environment = {
  production: true,
  // apiUrl: 'https://checklist-api.vegease.in/api/v1/',
  //  apiUrl: 'http://localhost:3000/api/v1/',
  apiUrl: 'https://maintenance-api.k1bistros.com/api/v1/',
  deviceToken : "deviceToken",
  platform: '3',
   timezone: '-330',
};
